import styled from 'styled-components';
import HandsDesk from '../../../assets/images/awaken/awaken_slider_hands_1920_tiny.png';

export const BannerWrapper = styled.section`
  padding: 180px 0 100px 0;
  background-color: #f16600;
  background-image: url(${HandsDesk});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom center;
  min-height: 520px;
  display: flex;
  align-items: center;

  @media (max-width: 1199px) {
    padding: 160px 0 80px 0;
    min-height: 480px;
  }
  @media (max-width: 990px) {
    padding: 140px 0 70px 0;
    min-height: 440px;
    background-size: cover;
  }
  @media (max-width: 767px) {
    padding: 130px 0 60px 0;
    min-height: 420px;
  }
  @media (max-width: 575px) {
    padding: 120px 0 50px 0;
    min-height: auto;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;
